import { render, staticRenderFns } from "./TestSortQuestions.vue?vue&type=template&id=99755970&"
import script from "./TestSortQuestions.vue?vue&type=script&lang=ts&"
export * from "./TestSortQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports